/*=============================================== GridPage ===============================================*/

import { Grid } from "tsx-library-julseb"

import { ComponentsLayout, GridItem } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, paddingObject } from "data"

const GridPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Grid col={3} columnGap="s" rowGap="xxs">
                    <GridItem />
                    <GridItem />
                    <GridItem />
                    <GridItem />
                    <GridItem />
                </Grid>
            ),
            code: '<Grid col={3} columnGap="s" rowGap="xxs">\n    \n</Grid>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "col",
            type: "number or string",
        },
        {
            subtitle: "gap",
            type: "string or number",
            possible: commonProps.spacers,
        },
        {
            subtitle: "columnGap",
            type: "string or number",
            possible: commonProps.spacers,
        },
        {
            subtitle: "rowGap",
            type: "string or number",
            possible: commonProps.spacers,
        },
        {
            subtitle: "justifyItems",
            type: "string",
            possible: commonProps.gridJustifyItems,
            default: "stretch",
        },
        {
            subtitle: "alignItems",
            type: "string",
            possible: commonProps.gridAlignItems,
            default: "stretch",
        },
        {
            subtitle: "justifyContent",
            type: "string",
            possible: commonProps.gridJustifyContent,
        },
        {
            subtitle: "alignContent",
            type: "string",
            possible: commonProps.gridAlignContent,
        },
        {
            subtitle: "inline",
            intro: (
                <>
                    Set the <code>display</code> to <code>inline-grid</code>
                </>
            ),
            type: "boolean",
        },

        ...paddingObject(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default GridPage
